<template>
    <table>
        <thead>
            <tr>
                <th>ID</th>
                <th v-if="paymentsHasStoresInformation">TIENDA</th>
                <th>M. PAGO</th>
                <th v-if="paymentsHasStoresInformation">PLAN</th>
                <th>FECHA PAGO</th>
                <th>MONTO</th>
                <th v-if="showActions">ACCIONES</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="payment in payments" :key="payment.id">
                <td>{{payment.id}}</td>
                <td v-if="paymentsHasStoresInformation">{{payment.store.name}}</td>
                <td>{{payment.payment_method}}</td>
                <td v-if="paymentsHasStoresInformation">{{ planById(payment.store.plan_id).nombre }}</td>
                <td>{{payment.payment_date === null ? '--' : payment.payment_date_for_humans  }}</td>
                <td>${{priceFormatter(payment.amount)}}</td>
                <td v-if="showActions">
                    <div class="d-flex flex-row">
                        <AppButton class="mr-25" @click="$emit('update', payment)">U</AppButton>
                        <AppButton @click="$emit('destroy', payment)">D</AppButton>
                    </div>
                    
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import priceFormatter from '@/priceFormatter';
import { useMainStore } from '@/store';
import { mapState } from 'pinia';
import AppButton from './ui/AppButton.vue';
    export default {
        emits:['update','destroy'],
    computed: {
        ...mapState(useMainStore, ["planById"]),
        paymentsHasStoresInformation() {
            return this.payments[0].store !== undefined;
        },
    },
    props: {
        payments: {
            type: Array,
            required: true,
        },
        showActions: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        priceFormatter(v) {
            return priceFormatter(v);
        }
    },
    components: { AppButton }
}
</script>